<style scoped>
.dropdown-menu::after,
.dropdown-menu::before {
  content: none;
}
</style>

<template>
  <td>
    <div
      v-if="!model.deleted_at"
      ref="dropdown"
      class="dropdown"
      :class="{ show: show, dropup: index > 10, dropleft: true }"
    >
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <div @click="copySlug" class="dropdown-item">Trackingcode kopieren</div>
        <div @click="copyExample" class="dropdown-item">
          URL-Beispiel kopieren
        </div>
        <div @click="copyPublicDOISlug" class="dropdown-item">
          DOI Link kopieren
        </div>
        <div @click="copyPublicSOISlug" class="dropdown-item">
          SOI Link kopieren
        </div>
        <div @click="edit" :disabled="deleting" class="dropdown-item">
          Bearbeiten
        </div>
        <div @click="remove" :disabled="deleting" class="dropdown-item">
          Löschen
        </div>
      </div>
    </div>
  </td>
</template>

<script>
import { catchOutsideClicks } from "@/js/bodyClick.js";

export default {
  props: ["model", "tableId", "index"],
  data() {
    return {
      show: false,
      deleting: false
    };
  },
  mounted() {
    catchOutsideClicks(this.$refs.dropdown, () => {
      this.show = false;
    });
  },
  methods: {
    copySlug() {
      navigator.clipboard.writeText(this.model.slug);
      this.$notify({
        title: "Trackingcode kopiert",
        type: "success"
      });
    },
    copyExample() {
      let url = `${Laravel.domains[0]}?ac=${this.model.slug}`;
      if (this.model["one_click_passing"]) {
        url = `${Laravel.domains[0]}/one-click-passing?ac=${this.model.slug}&email=ZXhhbXBsZUBkb2FtaW4uY29t`;
      }
      navigator.clipboard.writeText(url);
      this.$notify({
        title: "URL-Beispiel kopiert",
        type: "success"
      });
    },
    copyPublicDOISlug() {
      navigator.clipboard.writeText(
        `${Laravel.domains[0]}/affiliate/public/${this.model.public_slug}`
      );
      this.$notify({
        title: "DOI Link kopiert",
        type: "success"
      });
    },
    copyPublicSOISlug() {
      navigator.clipboard.writeText(
        `${Laravel.domains[0]}/affiliate/public/${this.model.soi_slug}`
      );
      this.$notify({
        title: "SOI Link kopiert",
        type: "success"
      });
    },
    edit() {
      if (this.deleting) {
        return;
      }

      this.$router.push({ path: new URL(this.model.update_page_url).pathname });
    },
    remove() {
      if (this.deleting) {
        return;
      }

      let confirmed = confirm("Sicher?");
      if (!confirmed) {
        return;
      }

      this.deleting = true;

      this.$store
        .dispatch("affiliate/delete", {
          url: this.model.delete_url,
          id: this.model.id
        })
        .then(() => {
          this.$emit("table-update", { count: true });
        })
        .finally(() => {
          this.deleting = false;
        });
    }
  },
  computed: {
    modalPrefix() {
      return this.model.id;
    }
  }
};
</script>
